import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useParams, Navigate } from "react-router-dom";

import HomePage from "./pages/HomePage";
import OfferPage from "./pages/OfferPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import IntakePage from "./pages/IntakePage";
import SuccessPage from "./pages/SuccessPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import AdminPage from "./pages/AdminPage";
import SocialProofToast from "./components/SocialProofToast";

const OfferRoute = () => {
  const { slug } = useParams();
  if (!["pack-99", "monthly-175"].includes(slug)) {
    return <Navigate to="/" replace />;
  }
  return <OfferPage slug={slug} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/offer/:slug" element={<OfferRoute />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/intake" element={<IntakePage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <SocialProofToast />
      </BrowserRouter>
    </div>
  );
}

export default App;
